import { reactive } from 'vue';
import { createStore } from 'vuex';
import itemData from '@/_components/json/_items.json';
import itemDataEn from '@/_components/json/_items_en.json';

export default createStore({
  state: {
    assetsPath: '/collections/2022autumn-luxury/assets/',
    //itemContainerH: 0,
    items: itemData,
    items_en: itemDataEn,
    showLoad: true,
    headBlack: false,
    seriesBlack: false,
    loadTime: 1.0,
    lang: gFNS.lang,
    pathPrefix: (gFNS.lang === 'en') ? 'en/' : '',
    officialURL: {
      ja: 'https://www.fournines.co.jp/',
      en: 'https://www.fournines.co.jp/en/'
    },
    shoplistURL: {
      ja: 'https://www.fournines.co.jp/shops/',
      en: 'https://www.fournines.co.jp/en/shops/'
    },
  },
  mutations: {
    sendGA(state, prop) {
      if (prop.path === '') prop.path = location.pathname;
      ga('send', 'event', prop.action, prop.path, prop.label);
    },
    setShowLoad(state, isShow) {
      state.showLoad = isShow;
    },
    setHeadBlack(state, isBlack) {
      state.headBlack = isBlack;
    },
    setSeriesBlack(state, isBlack) {
      state.seriesBlack = isBlack;
    },
    setLang(state, lang) {
      state.lang = lang;
    },
  },
  actions: {
  },
  getters: {
    // containerH(state) {
    //   return state.itemContainerH;
    // },
    getItemAll: (state) => {
      return state.items;
    },
    getItemEnAll: (state) => {
      return state.items_en;
    },
    assetsPath(state) {
      return state.assetsPath;
    },
    showLoad: (state) => {
      return state.showLoad;
    },
    loadTime: (state) => {
      return state.loadTime;
    },
    headBlack: (state) => {
      return state.headBlack;
    },
    seriesBlack: (state) => {
      return state.seriesBlack;
    },
    lang: (state) => {
      return state.lang;
    },
    pathPrefix: (state) => {
      return state.pathPrefix;
    },
    officialURL: (state) => {
      return state.officialURL;
    },
    shoplistURL: (state) => {
      return state.shoplistURL;
    },
  },
  modules: {
  }
});